import React from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';

import { Button } from 'core/components/button';
import BaseDialog from 'core/components/base-dialog';
import { Label } from 'core/components/label';
import useStyles from '../footer.styles';

const ConfirmPullMVRModal = ({ onClose, onConfirm, open }) => {
  const classes = useStyles();
  return (
    <BaseDialog onClose={onClose} open={open}>
      <Label className={classes.mainLabel} type="greenBig">
        Are you sure you want to run motor vehicle record (MVR) reports?
      </Label>
      <Label type="greenSmall">We recommend running MVR closer to binding the sale.</Label>
      <Grid className={classes.buttonContainer} container justifyContent="flex-end">
        <Button className={classes.buttons} variant="contained" color="secondary" onClick={onClose}>
          No, go back
        </Button>
        <Button className={classes.buttons} variant="contained" color="primary" onClick={onConfirm}>
          Yes, run these reports
        </Button>
      </Grid>
    </BaseDialog>
  );
};
ConfirmPullMVRModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default ConfirmPullMVRModal;
